module.exports = __webpack_public_path__ + "img/murumbi.13589314.svg";